<template>
	<v-chip v-if="text && text !== '—'" size="small" :color="chipColor" variant="tonal">
		{{ text }}
	</v-chip>
	<span v-else class="text-medium-emphasis">—</span>
</template>

<script>
import {
	enumLabel,
	enumColor,
	COMMON_STATUS_LABELS,
	COMMON_STATUS_COLORS,
	BEAN_TYPE_LABELS,
	BEAN_TYPE_COLORS,
	STOCK_LOG_TYPE_LABELS,
	STOCK_LOG_TYPE_COLORS,
	BATCH_TYPE_LABELS,
	BATCH_TYPE_COLORS,
	SUPPLIER_TYPE_LABELS,
	SUPPLIER_TYPE_COLORS,
	CUPPING_STATUS_LABELS,
	CUPPING_STATUS_COLORS,
	CUPPING_METHOD_LABELS
} from './enumLabels'

const KINDS = {
	status: { labels: COMMON_STATUS_LABELS, colors: COMMON_STATUS_COLORS },
	beanType: { labels: BEAN_TYPE_LABELS, colors: BEAN_TYPE_COLORS },
	stockLogType: { labels: STOCK_LOG_TYPE_LABELS, colors: STOCK_LOG_TYPE_COLORS },
	batchType: { labels: BATCH_TYPE_LABELS, colors: BATCH_TYPE_COLORS },
	supplierType: { labels: SUPPLIER_TYPE_LABELS, colors: SUPPLIER_TYPE_COLORS },
	cuppingStatus: { labels: CUPPING_STATUS_LABELS, colors: CUPPING_STATUS_COLORS },
	cuppingMethod: { labels: CUPPING_METHOD_LABELS, colors: {} }
}

export default {
	name: 'EnumChip',
	props: {
		value: { type: [String, Number], default: '' },
		kind: { type: String, default: 'status' },
		labels: { type: Object, default: null },
		colors: { type: Object, default: null }
	},
	computed: {
		preset() {
			return KINDS[this.kind] || KINDS.status
		},
		text() {
			return enumLabel(this.labels || this.preset.labels, this.value)
		},
		chipColor() {
			return enumColor(this.colors || this.preset.colors, this.value, 'default')
		}
	}
}
</script>
